/* global $ */
import { bb } from "$json";
/* edit-earlier-direct
 *
 * Allow immediate editing of previous questions
 *
 * Author: Niels Giesen
 * Copyright 2021 Berkeley Bridge
 *
 */

function debounce(func, wait, immediate) {
  let timeout;
  return function (...args) {
    const context = this;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    window.clearTimeout(timeout);
    timeout = window.setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function editme(ev, _args) {
  bb.step("update", null, {
    groupElt: ev.target.closest(".group"),
    groupid: bb.getVar("screenid")
  });
  //  return false;
}

$(document).on(
  "change",
  ".group:not(.selected) :input",
  debounce(editme, 132, false)
);
